/* aminos-card-slider
   - Mobile (< 750px): the theme's native Swiper (FoxTheme.Carousel); the active
     slide's card opens, the rest close.
   - Desktop (>= 750px): single-open accordion — opening one card closes any
     others, so only one is open at a time. */
if (!customElements.get('aminos-card-slider')) {
  customElements.define(
    'aminos-card-slider',
    class AminosCardSlider extends HTMLElement {
      connectedCallback() {
        this.mobileSliderEnabled = this.dataset.mobileSlider === 'true';
        this.swiperEl = this.querySelector('.swiper');
        this.cards = Array.from(this.querySelectorAll('details.aminos-ingredient-grid__card'));
        this.carousel = null;

        this.mql = window.matchMedia('(max-width: 749px)');
        this.onMqChange = this.sync.bind(this);
        this.mql.addEventListener('change', this.onMqChange);

        // Desktop single-open accordion.
        this.onToggle = this.handleToggle.bind(this);
        this.cards.forEach((card) => card.addEventListener('toggle', this.onToggle));

        this.sync();
      }

      disconnectedCallback() {
        if (this.mql) this.mql.removeEventListener('change', this.onMqChange);
        this.cards.forEach((card) => card.removeEventListener('toggle', this.onToggle));
        this.destroySwiper();
      }

      sync() {
        if (this.mql.matches) {
          if (this.mobileSliderEnabled) this.buildSwiper();
        } else {
          this.destroySwiper();
          this.enforceSingleOpen();
        }
      }

      /* Desktop: when a card opens, close the others. (Mobile open state is
         driven by the slider, so skip there.) */
      handleToggle(event) {
        if (this.mql.matches) return;
        const opened = event.target;
        if (!opened.open) return;
        this.cards.forEach((card) => {
          if (card !== opened && card.open) card.open = false;
        });
      }

      /* On entering desktop, collapse down to at most one open card. */
      enforceSingleOpen() {
        const open = this.cards.filter((card) => card.open);
        if (open.length > 1) {
          open.slice(1).forEach((card) => {
            card.open = false;
          });
        }
      }

      /* ---- Mobile Swiper ---- */
      buildSwiper() {
        if (this.carousel || !this.swiperEl) return;
        if (!window.FoxTheme || !window.FoxTheme.Carousel || !window.FoxTheme.Swiper) {
          window.requestAnimationFrame(() => this.sync());
          return;
        }

        this.carousel = new window.FoxTheme.Carousel(this.swiperEl, {
          slidesPerView: 1.12,
          spaceBetween: 16,
          threshold: 2,
          speed: 450,
          loop: false,
          watchOverflow: true,
          autoHeight: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          on: {
            afterInit: (swiper) => this.syncOpenStates(swiper),
            slideChange: (swiper) => this.syncOpenStates(swiper),
          },
        });
        this.carousel.init();
      }

      syncOpenStates(swiper) {
        swiper.slides.forEach((slide, i) => {
          const details = slide.querySelector('details');
          if (details) details.open = i === swiper.activeIndex;
        });
        if (typeof swiper.updateAutoHeight === 'function') {
          swiper.updateAutoHeight(250);
        }
      }

      destroySwiper() {
        if (this.carousel && this.carousel.slider) {
          this.carousel.slider.destroy(true, true);
        }
        this.carousel = null;
      }
    }
  );
}
